import { cashMovementApi } from "../../api";
import { CashMovementType } from "../../types/cash/CashMovementType";

const CashMovementService = {

  /**
   * 📜 Obtener historial de movimientos de una sesión
   *
   * Ejemplos:
   * /session/1
   * /session/1?types=WITHDRAWAL
   * /session/1?types=ADJUSTMENT_IN&types=ADJUSTMENT_OUT
   */
  getSessionMovements: async (
    sessionId: number,
    types?: CashMovementType[]
  ) => {

    let query = "";

    if (types && types.length > 0) {
      const params = types.map(t => `types=${t}`).join("&");
      query = `?${params}`;
    }

    const response = await cashMovementApi.fetchCustom(
      `/session/${sessionId}${query}`
    );

    return response.data;

  }

};

export default CashMovementService;